var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SrOnly } from '../sr-only';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var Pill = /** @class */ (function (_super) {
    __extends(Pill, _super);
    function Pill(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.userRequest = 'onUserRequest';
        _this.closeBegin = 'onCloseBegin';
        _this.closeEnd = 'onCloseEnd';
        _this.state = {};
        _this.state['stage'] = _this.props.isOpen ? 'open' : 'closed';
        _this.onAnimationEnd = _this.onAnimationEnd.bind(_this);
        _this.clickHandler = _this.clickHandler.bind(_this);
        return _this;
    }
    Pill.prototype.render = function () {
        var _this = this;
        return this.state.stage !== 'closed' ? (React.createElement("div", { "data-e2e": this.props.dataE2e, onAnimationEnd: function (event) { return _this.onAnimationEnd(event); }, className: 'cg-pill-ctx ' +
                (this.state.stage === 'closing' ? 'cg-element-hidden ' : '') },
            React.createElement("button", { type: "button", "data-e2e": "cg-pill-button", disabled: this.props.isDisabled, onClick: function (event) { return _this.clickHandler(event); }, className: 'cg-pill ' + (this.props.size === 'small' ? 'cg-is-small ' : '') },
                this.props.srLabel ? React.createElement(SrOnly, null, this.props.srLabel) : null,
                this.props.children))) : null;
    };
    Pill.prototype.isControlled = function () {
        return this.props.controlMode === 'controlled';
    };
    Pill.prototype.cg_change = function (prevProps) {
        if (prevProps.isOpen === false && this.props.isOpen) {
            this.attachToDOM();
        }
        if (prevProps.isOpen === true && !this.props.isOpen) {
            this.closePill();
        }
    };
    Pill.prototype.clickHandler = function (event) {
        event.stopPropagation();
        if (!this.isControlled()) {
            this.writeState('stage', 'closing');
        }
        this.emit(this.userRequest);
    };
    Pill.prototype.attachToDOM = function () {
        this.writeState('stage', 'open');
    };
    Pill.prototype.detachFromDOM = function () {
        this.writeState('stage', 'closed');
    };
    Pill.prototype.closePill = function () {
        this.writeState('stage', 'closing');
        this.emit(this.closeBegin);
    };
    Pill.prototype.onAnimationEnd = function (event) {
        if (event.animationName === 'cg-pill-disappear') {
            this.emit(this.closeEnd);
            this.detachFromDOM();
        }
    };
    Pill.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Pill.defaultProps = {
        isDisabled: false,
        dataE2e: 'cg-pill',
        size: 'large',
        isOpen: true,
        controlMode: 'uncontrolled',
        srLabel: 'Remove',
        slot: 'groupPill',
    };
    Pill.displayName = 'Pill';
    return Pill;
}(React.Component));
export { Pill };
